<template>
    <div v-show="isActive" class="tab-pane" :aria-hidden="!isActive" role="tabpanel" :class="{active: isActive}">
        <slot />
    </div>
</template>

<script>
export default {
  props: {
    name: { required: true },
    icon: { required: false },
    selected: { default: false },
  },

  data() {
    return {
      isActive: false,
    };
  },

  mounted() {
    this.isActive = this.selected;
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/tab.vue